module.exports = __webpack_public_path__ + "img/培训类标题.604b90ef.png";